import { render, staticRenderFns } from "./option-manage-goods.vue?vue&type=template&id=0d67738e"
import script from "./option-manage-goods.vue?vue&type=script&lang=js"
export * from "./option-manage-goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports